

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SetPreset, SetWaterLevel, SetForecastType } from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from './PresetButtons.css';
import withStyles from '../../decorators/withStyles';
import { gaEvent } from "../../utils/utils";


class PresetButtons extends Component {

  static propTypes = {
    preset: PropTypes.string.isRequired,
    presetLevels: PropTypes.object.isRequired,
    waterLevel: PropTypes.object.isRequired,
    forecastPresets: PropTypes.array.isRequired,
    horizontal: PropTypes.bool,
    handleAdvancedClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    horizontal: false,
    groupName: "Sea level scenario"
    // forecastPresets: [
    //   "NCA_lo",
    //   "NCA_inthi",
    //   "NCA_high"
    // ]
  };

  handleClick = idx => {
    gaEvent('configure', 'forecastType-preset', this.props.forecastPresets[idx]);
    this.props.dispatch(SetPreset(idx));
    this.props.dispatch(SetForecastType(this.props.forecastPresets[idx]));
  };

  handleEmissionsClick = idx => {
    // this.props.dispatch(SetPreset(idx));
    this.props.callback(idx);
  };

  render() {
    var isActive;
    if (this.props.scenario) {
      isActive = idx => this.props.forecastPresets[idx] === this.props.scenario ? "active" : "";
    } else {
      isActive = idx => this.props.forecastPresets[idx] === this.props.forecastType ? "active" : "";
    }

    var classes = this.props.horizontal ? " horizontal" : "";
    classes += this.props.header ? " header" : "";
    classes += this.props.menuOpen ? " menu" : "";

    return (
      <div className={"PresetButtons" + classes}>
        {!this.props.horizontal ?
          <div>
            <div className="preset-div">
              <button>
                <span className="label">{this.props.groupName}</span>
              </button>
            </div>
            {this.props.groupName === "Climate pollution scenario" ?
              <span>
                            <button onClick={this.handleEmissionsClick.bind(null, 2)}
                                    className={"preset top fast " + isActive(2) + classes}>High
            </button>
            <button onClick={this.handleEmissionsClick.bind(null, 1)}
                    className={"preset middle med " + isActive(1) + classes}>Medium
            </button>
            <button onClick={this.handleEmissionsClick.bind(null, 0)}
                    className={"preset bottom slow " + isActive(0) + classes}>Low
            </button>
              </span>
                :
                <span>
                {this.props.forecastPresets.length > 3 ?
                    <button onClick={this.handleClick.bind(null, 3)}
                            className={"preset tiptop xtreme " + isActive(3) + classes}>Extreme</button>
                    : null }
            <button onClick={this.handleClick.bind(null, 2)}
                    className={"preset top fast " + isActive(2) + classes}>Fast rise
            </button>
            <button onClick={this.handleClick.bind(null, 1)}
                    className={"preset middle med " + isActive(1) + classes}>Medium
            </button>
            <button onClick={this.handleClick.bind(null, 0)}
                    className={"preset bottom slow " + isActive(0) + classes}>Slow rise
            </button>
                  </span>
            }
          </div>
        : <span name="preset-button-span">
          {this.props.header ? <label htmlFor="preset-button-span">Sea Level Rise</label> : null }
          <button onClick={this.handleClick.bind(null, 0)}
                  className={"preset top slow " + isActive(0) + classes}>Slow</button>
          <button onClick={this.handleClick.bind(null, 1)}
                  className={"preset middle med " + isActive(1) + classes}>Medium</button>
          <button onClick={this.handleClick.bind(null, 2)}
                  className={"preset bottom fast " + isActive(2) + classes}>Fast</button>
        </span>}
        <a className="small-text advanced" href="" onClick={e => {e.preventDefault(); this.props.handleAdvancedClick(e)}}>Advanced</a>
      </div>
    );
  };

}

function stateToProps(state) {
  return {
    preset: state.preset,
    waterLevel: state.waterLevel,
    presetLevels: state.presetLevels,
    forecastType: state.forecastType
  }
}

export default compose(
  withStyles(styles),
  connect(stateToProps),
)(PresetButtons);
